export const cocoLoaderStateSelector = ({cocoLoaderState}) => cocoLoaderState